import axios from 'axios';
import {downloadFile} from "../../utils/file/download";

export class ControlPanelService {
    getControlPanelLoan(
        loanId,
        flowId,
        lenderId,
        borrowerId,
        rentTypeId,
        concertDate,
        maturityDate,
    ) {
        return axios.get('/appapv/getControlPanelLoan.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idFolioPrest: loanId === undefined ? 0 : loanId,
                idFlujo: flowId === undefined ? 0 : flowId,
                idInstitucionPTM: lenderId === undefined ? 0 : lenderId,
                idInstitucionPTT: borrowerId === undefined ? 0 : borrowerId,
                idTipoRenta: rentTypeId === undefined ? 0 : rentTypeId,
                concertDate: concertDate === '' ? '' :
                    concertDate.getFullYear() + "-" +
                    (concertDate.getMonth() + 1) + "-" +
                    concertDate.getDate(),
                maturityDate: maturityDate === '' ? '' :
                    maturityDate.getFullYear() + "-" +
                    (maturityDate.getMonth() + 1) + "-" +
                    maturityDate.getDate(),
            }
        }).then(res => res.data.payload);
    }

    getNewLoan(
        loanId
    ) {
        return axios.get('/appapv/getNewLoan.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                folio: loanId
            }
        }).then(res => res.data.payload);
    }

    getTransactionalLog(
        loanId
    ) {
        return axios.get('/appapv/getTransactionalLog.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idFolioPrest: loanId
            }
        }).then(res => res.data.payload);
    }

    getReportCurrentLoanControlPanel(format, rol) {
        let url = '';
        let params = rol ? {rol: rol} : {};

        switch (format) {
            case "XLS":
                url = '/appapv/getReportCurrentLoanControlPanelXls.action';
                break;
            case "PDF":
                url = '/appapv/getReportCurrentLoanControlPanelPdf.action';
                break;
            case "CSV":
                url = '/appapv/getReportCurrentLoanControlPanelCsv.action';
                break;
            default:
                break;
        }

        return downloadFile(url, params);
    }

    getReportMaturityControlPanel(format) {
        let url = '';

        switch (format) {
            case "XLS":
                url = '/appapv/getReportMaturityControlPanelXls.action';
                break;
            case "PDF":
                url = '/appapv/getReportMaturityControlPanelPdf.action';
                break;
            case "CSV":
                url = '/appapv/getReportMaturityControlPanelCsv.action';
                break;
            default:
                break;
        }

        return downloadFile(url);
    }

    anticipatedMaturity(loanId) {
        return axios.post('/appapv/anticipatedMaturity.action', {}, {
            params: {
                folio: loanId,
            }
        }).then(res => res.data.payload);
    }

    updateGuaranteeSelectionRestriction(loanId, isRestricted) {
        return axios.post('/appapv/updateGuaranteeSelectionRestriction.action', {}, {
            params: {
                folio: loanId,
                seleccionGaran: isRestricted
            }
        }).then(res => res.data.payload);
    }

    returnLoanMaturity(loanId, returnDays) {
        return axios.post('/appapv/returnLoanMaturity.action', {}, {
            params: {
                folio: loanId,
                plazo: returnDays,
            }
        }).then(res => res.data);
    }

    getSettlementStatus(
        loanId
    ) {
        return axios.get('/appapv/getSettlementStatus.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idFolioPrest: loanId
            }
        }).then(res => res.data.payload);
    }

    getGuaranteeLoanForChange(
        loanId,
        maturity
    ) {
        let params;

        if (maturity > 0) {
            params = {
                folio: loanId,
                plazo: maturity,
            }
        } else {
            params = {
                folio: loanId,
            }
        }


        return axios.get('/appapv/getGuaranteeLoanForChange.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: params
        }).then(res => res.data.payload);
    }

    getGuaranteeAccountForChange(
        loanId,
        maturity,
        account
    ) {
        return axios.get('/appapv/getGuaranteeAccountForChange.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                folio: loanId,
                plazo: maturity,
                cuenta: account
            }
        }).then(res => res.data.payload);
    }

    setFlowSettlement(
        loanId,
    ) {
        return axios.get('/appapv/setFlowSettlement.action', {
            headers: {},
            params: {
                idFolioPrest: loanId,
            }
        }).then(res => res.data);
    }

}